const errorBEMessaeKeys = {
    CAN_NOT_UPDATE_CANCELLED_PROCESS_EVIDENCE: 'CAN_NOT_UPDATE_CANCELLED_PROCESS_EVIDENCE',
    ASSET_NO_LONGER_APPLICABLE_FOR_PROCESS_DEFINITION: 'ASSET_NO_LONGER_APPLICABLE_FOR_PROCESS_DEFINITION',
    SHIPMENT_ALREADY_CONFIRMED: 'SHIPMENT_ALREADY_CONFIRMED',
}

export default errorBEMessaeKeys
